const dataObj = {
    fullPrivilege: [
        {
            name: "免费查重",
            icon: "/static/images/privilege_vip_icon1.png",
            isNew: true
        },{
            name: "免费降重",
            icon: "/static/images/privilege_vip_icon2.png",
            isNew: true
        },{
            name: "下载不限篇数",
            icon: "/static/images/privilege_vip_icon3.png",
            isNew: false
        },{
            name: "批量下载",
            icon: "/static/images/privilege_vip_icon4.png",
            isNew: false
        },{
            name: "免费求助",
            icon: "/static/images/privilege_vip_icon5.png",
            isNew: false
        },{
            name: "PDF转Word",
            icon: "/static/images/privilege_vip_icon6.png",
            isNew: false
        },{
            name: "专属客服",
            icon: "/static/images/privilege_vip_icon7.png",
            isNew: false
        },{
            name: "PPT模板",
            icon: "/static/images/privilege_vip_icon8.png",
            isNew: false
        },{
            name: "屏蔽广告",
            icon: "/static/images/privilege_vip_icon9.png",
            isNew: false
        },{
            name: "文档去水印",
            icon: "/static/images/privilege_vip_icon10.png",
            isNew: false
        }
    ],
    payMethodList:[
        {
            name: "微信支付",
            code: "wxPay",
            icon: "/static/images/vip_wexin.png",
            description: "使用微信扫码支付",
            isCheck: true
        },{
            name: "支付宝支付",
            code: 'aliPay',
            icon: "/static/images/vip_zhifubao.png",
            description: "使用支付宝扫码支付",
            isCheck: false
        },{
            name: "学术币支付",
            code: "points",
            icon: "",
            description: "使用学术币支付"
        }
    ],
    notices:[
        "1. 学书币可用于支付查重、降重费用、或购买会员。",
        "2. 学书币为虚拟币，充值后不会过期，无法提现，也无法转赠他人。",
        "3. 如遇到问题，可前往爱学术公众号联系客服处理。"
    ]

}

export default dataObj


// WEBPACK FOOTER //
// ./src/components/recharge/data.js